<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Goodwill en Overige immateriële vaste activa
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Immateriële vaste activa zijn niet-tastbare kapitaalgoederen, zoals:
                <li class="list">goodwill (de contante waarde van de overwinst van de onderneming; de waarde van
                    gekochte goodwill hoort bij de activa)
                </li>
                <li class="list">vergunningen, concessies en intellectuele eigendommen</li>
                <li class="list">kosten van onderzoek en ontwikkeling</li>
                <li class="list">productierechten voor agrariërs (verhandelbare rechten voor landbouwers om bepaalde
                    producten te mogen produceren)
                </li>

                <div class="space20"></div>

                <b>Kosten van onderzoek en ontwikkeling</b><br/>
                Je kunt kosten van onderzoek en ontwikkeling alleen activeren als het gaat om het ontwikkelen van
                concrete technologieën en producten.

                <div class="space20"></div>

                <b>Afschrijving op vergunningen, concessies en intellectuele eigendommen</b><br>
                Voorbeelden van vergunningen, concessies en intellectuele eigendommen zijn:
                <li class="list">vervoersvergunningen</li>
                <li class="list">octrooi en patenten</li>
                <li class="list">auteursrechten</li>

                Deze moeten worden geboekt tegen de kostprijs of tegen de lagere bedrijfswaarde.
                <div class="space10"></div>
                De uitgaven voor vergunningen, concessies en intellectuele eigendommen moet je toerekenen aan de jaren
                waarin ze zullen worden benut. Per jaar mag je van de aanschaf- of voortbrengingskosten maximaal 20%
                afschrijven. Houd bij de afschrijving rekening met de restwaarde.
                <div class="space10"></div>
                Moet je voor de instandhouding van de vergunningen, intellectuele eigendommen en concessies periodiek
                betalingen doen, bijvoorbeeld jaarlijks? Dan mag je dat hele bedrag in het jaar van betaling van de
                winst aftrekken.
                <div class="space10"></div>
                <b>Aanschafwaarde</b><br/>
                Vermeld bij het veld 'Aanschafwaarde' de aanschafwaarde van de balanspost per einde van het
                boekjaar (veelal 31 december) is opgenomen.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Gebouwen en terreinen, Machines en installaties, Overige materiële vaste activa
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                We hebben het hier over de materiële vaste activa. Dat zijn tastbare kapitaalgoederen, zoals:
                <li class="list">(bedrijfs)gebouwen en terreinen</li>
                <li class="list">machines en installaties</li>
                <li class="list">inventaris</li>
                <li class="list">auto's en overige transportmiddelen</li>
                <li class="list">vaste bedrijfsmiddelen in uitvoering en vooruitbetaalde bedragen op materiële vaste
                    activa
                </li>
                De kosten van aanschaf of voortbrenging van deze bedrijfsmiddelen moet je activeren op de balans
                en afschrijven. Tot de materiële vaste activa behoren niet:
                <li class="list">goederen waarvan de kosten tot de lopende uitgaven van je onderneming zijn te rekenen
                </li>
                <li class="list">goederen die zijn bestemd voor de omzet</li>

                <div class="space10"></div>

                <b>Eigen gebruik gebouwen en terreinen of in gebruik bij derden</b>
                Voor ondernemers in de Inkomstenbelasting gold tot en met 2023: voor gebouwen die de ondernemer verhuurt
                (gebouw ter belegging) is de WOZ-waarde de bodemwaarde. Voor gebouwen in eigen gebruik is de bodemwaarde
                50% van de WOZ-waarde. <br/>
                Vanaf 2024 is de bodemwaarde voor alle gebouwen gelijk aan de WOZ-waarde. Maar heeft de ondernemer vóór
                1 januari 2024 een gebouw in eigen gebruik genomen? En is er nog geen 3 jaar afgeschreven? Dan mag je
                tot 3 jaar na het in gebruik nemen van het gebouw nog rekening houden met 50% van de WOZ-waarde als
                bodemwaarde. <br/>
                Meer informatie over afschrijvingen van bedrijfspanden vind je <a target="_blank"
                                                                                  href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/winst/inkomstenbelasting/inkomstenbelasting_voor_ondernemers/afschrijving/afschrijving_bedrijfspand">hier</a>.

                <div class="space10"></div>

                <b>Aanschafkosten</b><br/>
                Vul bij 'Aanschafkosten' in: de prijs die de ondernemer bij aanschaf moest betalen, inclusief
                de kosten die er zijn gemaakt tot aan de ingebruikname (zoals aankoop- en installatiekosten). Onder de
                aanschafkosten verstaan we ook de voortbrengingskosten. Deze kosten van voortbrenging zijn de kosten
                voor een
                bedrijfsmiddel dat de ondernemer zelf hebt gemaakt.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Financiële vaste activa
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Financiële vaste activa zijn bijvoorbeeld langlopende vorderingen. Denk aan:
                <li class="list">langlopende vorderingen op participanten<br/>
                    Neemt de ondernemer deel in een persoonlijk samenwerkingsverband, bijvoorbeeld een vennootschap
                    onder
                    firma (vof)? Dan vul je de vordering in bij 'Vorderingen'.
                </li>
                <li class="list">langlopende vorderingen op gelieerde maatschappijen</li>
                <li class="list">overige langlopende vorderingen.</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Voorraad en Onderhanden werk
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voorraden zijn bijvoorbeeld:
                <li class="list">grond- en hulpstoffen</li>
                <li class="list">gereed product en handelsgoederen</li>
                <li class="list">vooruitbetaling op voorraden.</li>

                <div class="space10"></div>

                Bij onderhanden werk gaat het om langlopende projecten en opdrachten, zoals een bouwwerk waaraan langere
                tijd wordt gewerkt.
                <div class="space10"></div>
                In de kostprijs neem je alle direct toerekenbare kosten mee, zoals lonen, materialen, kosten en
                afschrijving van gebruikte machines, energie en werk door derden. Het constante deel van de algemene
                kosten, zoals loonkosten van de algemene leiding en huisvestingskosten, moet je in de waardering
                opnemen.
                Verder moet je (een evenredig deel van) de winstopslag activeren.
                <div class="space10"></div>
                Je neemt de winst voortschrijdend. Dit betekent dat je niet mag wachten met winstneming tot het werk of
                de
                opdracht is afgerond. Als een opdracht voor de helft klaar is, moet je dus de helft van de
                overeengekomen
                prijs op dat moment activeren. Dit activeren leidt vervolgens tot winstneming.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Debiteuren, Omzetbelasting en Overige vorderingen
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul bij 'Debiteuren' de gewone handelsvorderingen op gelieerde maatschappijen en participanten in, als
                die te maken hebben met de normale omzet van het bedrijf. <br/>
                <div class="space10"></div>
                <b>Nominale waarde</b>
                De nominale waarde van de debiteuren is de oorspronkelijke waarde van de vordering aan het einde van het boekjaar, zonder aftrek van eventuele
                voorzieningen door oninbaarheid.
                <div class="space10"></div>

                Bij 'Omzetbelasting' gaat het om de vordering van aangiften omzetbelasting die op de balansdatum nog
                niet zijn verwerkt, zoals de laatst ingediende maand- of kwartaalaangifte. Als je een bedrag aan
                omzetbelasting als vordering opgeeft, dan moet je dit vervolgens specificeren.

                <div class="space10"></div>

                Onder 'Overige vorderingen' vallen onder meer:
                <li class="list">kortlopende vorderingen op participanten</li>
                <li class="list">kortlopende vorderingen op gelieerde maatschappijen</li>
                <li class="list">overlopende activa.</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Effecten en Liquide middelen
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Effecten zijn zowel tijdelijke beleggingen als effectenportefeuilles voor de lange termijn die tot het
                ondernemingsvermogen behoren.

                <div class="space10"></div>

                Liquide middelen zijn bijvoorbeeld:
                <li class="list">banktegoeden</li>
                <li class="list">kastegoeden</li>
            </div>
        </div>
    </div>

</div>

